import { StorageKey } from 'types/storage/storage-key.enum';

export const deleteAuthStatus = (): void => 
    localStorage.removeItem(StorageKey.AuthStatus);